var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "project-control" },
    [
      !_vm.isTenant || _vm.canTenantRead
        ? [
            _c("DepositIndex", {
              ref: "depositIndex",
              attrs: { id: _vm.projectControlAchorIds.deposit },
              on: { "dirty-state-change": _vm.syncProjectControlDirtyState },
            }),
            _vm._v(" "),
            _vm.management
              ? _c("ManagementFeeIndex", {
                  ref: "managementFeeIndex",
                  attrs: { id: _vm.projectControlAchorIds.managementFee },
                  on: {
                    "dirty-state-change": _vm.syncProjectControlDirtyState,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _c("Insurance", {
              attrs: { id: _vm.projectControlAchorIds.insurance },
            }),
            _vm._v(" "),
            _c("InspectionTable", {
              ref: "InspectionTable",
              attrs: { id: _vm.projectControlAchorIds.inspection },
            }),
            _vm._v(" "),
            _c("FinalDocuments", {
              attrs: { id: _vm.projectControlAchorIds.finalDocuments },
            }),
          ]
        : _c("p", [_vm._v(_vm._s(_vm.$t("noTabPermission")))]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }